<bic-popup (close)="onCancel()" [hasBackdrop]="true"
           [title]="label ? 'Auswahlmöglichkeiten: ' + label : 'Auswahlmöglichkeiten anpassen'"
           customClass="w-[1000px]">
  <div bicPopupContent class="flex flex-col gap-4">
    @for (item of optionItems; track $index) {
      <div class="flex flex-row gap-4 items-center">
        <bic-input #optionInputHost class="flex-1"
                   [(value)]="item.value"
                   [showX]="false"
                   placeholder="Auswahlmöglichkeit eingeben"
                   (keydown.enter)="onOptionEnter($index, $event)">
        </bic-input>
        <button class="text-gray-400 hover:text-gray-600 transition" (click)="removeOption($index)">
          <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
        </button>
      </div>
    }

    <button class="flex flex-row items-center justify-center gap-2 py-2 text-sm font-medium text-gray-400 hover:text-gray-600"
            (click)="addOption()">
      <fa-icon [icon]="faPlus"></fa-icon>
      Auswahlmöglichkeit hinzufügen
    </button>
  </div>

  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="onCancel()">Abbrechen</bic-button>
    <bic-button (onClick)="onSave()">Übernehmen</bic-button>
  </div>
</bic-popup>
